import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import API from '../api/axios';
import { useAuth } from './AuthContext';

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([]);
  const [cartCount, setCartCount] = useState(0);
  const { user } = useAuth();

  const fetchCart = useCallback(async () => {
    if (!user) { setCartItems([]); setCartCount(0); return; }
    try {
      const res = await API.get('/cart/');
      setCartItems(res.data);
      setCartCount(res.data.reduce((sum, i) => sum + i.quantity, 0));
    } catch { setCartItems([]); }
  }, [user]);

  useEffect(() => { fetchCart(); }, [fetchCart]);

  const addToCart = async (productId, quantity = 1, size = null) => {
    await API.post('/cart/', { product_id: productId, quantity, size });
    fetchCart();
  };

  const removeFromCart = async (cartItemId) => {
    await API.delete(`/cart/${cartItemId}`);
    fetchCart();
  };

  const updateQuantity = async (cartItemId, quantity) => {
    await API.put(`/cart/${cartItemId}?quantity=${quantity}`);
    fetchCart();
  };

  const clearCart = async () => {
    await API.delete('/cart/');
    fetchCart();
  };

  const cartTotal = cartItems.reduce(
    (sum, item) => sum + parseFloat(item.product.price) * item.quantity, 0
  );

  return (
    <CartContext.Provider value={{ cartItems, cartCount, cartTotal, addToCart, removeFromCart, updateQuantity, clearCart, fetchCart }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);